import { BookAppointmentModalComponent } from '@modals/book-appointment-modal/book-appointment-modal.component';
import { CallUsModalComponent } from '@modals/call-us-modal/call-us-modal.component';
import { CarDemandModalComponent } from '@modals/car-demand-modal/car-demand-modal.component';
import { CarInfoModalComponent } from '@modals/car-info-modal/car-info-modal.component';
import { CebiaModalComponent } from '@modals/cebia-modal/cebia-modal.component';
import { ComplaintModalComponent } from '@modals/complaint-modal/complaint-modal.component';
import { ConfirmModalComponent } from '@modals/confirm-modal/confirm-modal.component';
import { FinancingCalculatorModalComponent } from '@modals/financing-calculator-modal/financing-calculator-modal.component';
import { OnlineFormAccessoriesModalComponent } from '@modals/online-form-accessories-modal/online-form-accessories-modal.component';
import { OnlineFormAddressModalComponent } from '@modals/online-form-address-modal/online-form-address-modal.component';
import { PhotoUploaderModalComponent } from '@modals/photo-uploader-modal/photo-uploader-modal.component';
import { ReservationModalComponent } from '@modals/reservation-modal/reservation-modal.component';
import { SaveFormModalComponent } from '@modals/save-form-modal/save-form-modal.component';
import { SellCarModalComponent } from '@modals/sell-car-modal/sell-car-modal.component';

export const ModalComponents = [
  BookAppointmentModalComponent,
  CallUsModalComponent,
  CarDemandModalComponent,
  CarInfoModalComponent,
  CebiaModalComponent,
  ComplaintModalComponent,
  ConfirmModalComponent,
  FinancingCalculatorModalComponent,
  OnlineFormAccessoriesModalComponent,
  OnlineFormAddressModalComponent,
  PhotoUploaderModalComponent,
  ReservationModalComponent,
  SaveFormModalComponent,
  SellCarModalComponent,
];
